import React, { useEffect, useState } from "react";
import { PageHeaderUi } from "../../ui/PageHeaderUi";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { UsuarioTable } from "./UsuarioTable";
import { useDispatch, useSelector } from "react-redux";
import { usuariosStartLoad } from "../../../actions/usuario";
import { UsuarioModal } from "./modal/UsuarioModal";
import { UsuarioScreen } from "./UsuarioScreen";

const LoadUsuarios = (dispatch) => {
  dispatch(usuariosStartLoad());
};
export const UsuarioListScreen = ({ handleOpenForm }) => {
  const dispatch = useDispatch();
  const handleActualizar = () => LoadUsuarios(dispatch);

  const { usuarios, loading } = useSelector((state) => state.usuario);
  return (
    <PageHeaderUi
      title="Usuarios"
      subTitle="Listado"
      extra={[
        <ButtonUi
          typeUi={TipoButtonConstants.Actualizar}
          key="Actualizar"
          onClick={handleActualizar}
        />,
        <ButtonUi
          typeUi={TipoButtonConstants.Nuevo}
          key="Nuevo"
          onClick={handleOpenForm}
        />,
      ]}
    >
      <UsuarioTable
        usuarios={usuarios}
        loading={loading}
        handleOpenForm={handleOpenForm}
      />
      <UsuarioModal />
    </PageHeaderUi>
  );
};
export const UsuarioList = () => {
  const dispatch = useDispatch();
  const [visibleForm, setVisibleForm] = useState(false);
  const handleOpenForm = () => setVisibleForm(true);
  const handleCloseForm = () => setVisibleForm(false);
  useEffect(() => {
    console.log("carga data");
    LoadUsuarios(dispatch);
  }, []);
  if (visibleForm)
    return (
      <UsuarioScreen openForm={visibleForm} handleCloseForm={handleCloseForm} />
    );
  else return <UsuarioListScreen handleOpenForm={handleOpenForm} />;
};
export default UsuarioList;
